import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { baseUrls, cmsLanguageCodes, contactNumber } from '../../library/constants/cms.js';
import PassiveChat, { OPEN_PASSIVE_CHAT_EVENT } from './passive-chat.jsx';
import styles from './header.module.scss';

const Header = ({ userLanguage, token, items, isApproved, hideChat = false }) => {
    const { t } = useTranslation();
    // Determine the base URL for the given user language
    const baseUrl = baseUrls[userLanguage] || 'https://www.leoprinting.com'; // Fallback URL
    const chatHidden = hideChat || !token;

    return (
        <>
            <header className={styles.headerWrapper}>
                <div className={styles.logo}>
                    <a href={baseUrl} target="_blank" rel="noopener noreferrer">
                        <img src="/images/logo.png" alt="Leoprinting" />
                    </a>
                </div>
                <div className={styles.actions}>
                    {!chatHidden && (
                        <button
                            className={`button--primary ${styles.chatButton}`}
                            onClick={() => window.dispatchEvent(new CustomEvent(OPEN_PASSIVE_CHAT_EVENT))}
                        >
                            <img src="/icons/chat.svg" alt="Chat" />
                            <span className={styles.chatButtonText}>{t('Chat with us')}</span>
                        </button>
                    )}
                    <a className={`button--primary ${styles.phoneButton}`} href={`tel:${contactNumber[userLanguage]}`} aria-label={contactNumber[userLanguage]}>
                        <img src="/icons/phone.svg" alt="Phone" />
                        <span className={styles.phoneButtonText}>{contactNumber[userLanguage]}</span>
                    </a>
                </div>
            </header>
            <PassiveChat token={token} items={items} isApproved={isApproved} hidden={chatHidden} />
        </>
    );
};
Header.propTypes = {
    userLanguage: PropTypes.oneOf(cmsLanguageCodes),
    token: PropTypes.string,
    items: PropTypes.array,
    isApproved: PropTypes.bool,
    hideChat: PropTypes.bool,
};

export default Header;